import { render, staticRenderFns } from "./ThgRegistrationFrontUploadCard.vue?vue&type=template&id=40d3d96e"
import script from "./ThgRegistrationFrontUploadCard.vue?vue&type=script&lang=ts"
export * from "./ThgRegistrationFrontUploadCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports